import React, { useState, useEffect , useRef } from 'react'
import Select from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete } from 'react-icons/ai';
import { FaTimes } from 'react-icons/fa';
import axios from 'axios'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Barcode from "react-barcode";
import jsPDF from "jspdf";
import ToastNotification from '../../components/ToastNotification';
import { GrFormView } from "react-icons/gr";
import { MdEdit } from "react-icons/md";
import autoTable from "jspdf-autotable";
import JsBarcode from "jsbarcode";
import { useLocation} from 'react-router-dom';

const Inventory = ({ adminData, companyID, branchID }) => {
 const location = useLocation();
const showAdd = location.state?.showAddForm;  


  const navigate = useNavigate();
  const formRef = useRef(null);

  const [filterCategory, setFilterCategory] = useState(null);
  const [filterGroup, setFilterGroup] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null)
  const [inventoryList, setInventoryList] = useState([
    { id: 1, name: 'product1', modelno: '112', mrp: '999', category: 'Category 1', discount: '30%' }
  ]);


  const [searchQuery, setSearchQuery] = useState('');
  const filteredData = inventoryList.filter((data) => (
    data.name.toLowerCase().includes(searchQuery.toLowerCase())
  ))
  const [showBarcode, setShowBarcode] = useState(false);
  const [detail, setDetail] = useState([]);
  const [newProduct, setNewProduct] = useState({
    name: '',
    short_name: '',
    uom: "",
    opening_qty: '',
    mrp: "",
    category: '',
    warranty: '',
    bin: '',
    barcode: '',
    model: '',
    opening_value: '',
    rate: '',
    tax: '',
    stock: '',
    group_item: '',
    description: '',
    brand: '',
    vendor: '',
    retailer: '',
    discount: '',
    discount_vendor: '',
    discount_retailer: '',
    hsn: '',
 
    min_stock: '',
    color: '',
    barcodeChecked: false,
    sr_no: '',
    salePriceVendor: "",
  salePriceRetailer: "",
  dynamic_fields:'',
  });
const[allCat,setAllCat] = useState([]);

useEffect(() => {
    if (showAdd) {
        setShowAddForm(true);
    }
}, [showAdd]);
  

  const [files, setFiles] = useState({
    file: null,
    video: null

  })
  const [categories, setCategories] = useState([]);
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [groups, setGroups] = useState([]);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [newGroupName, setNewGroupName] = useState("");
  const [unitModal, setUnitModal] = useState(false); 
  const [newUnitName, setNewUnitName] = useState('');
  const [units, setUnits] = useState([]);
  const [uoms, setUoms] = useState([]);
  const [showUomModal, setShowUomModal] = useState(false);
  const [newUomName, setNewUomName] = useState("");
  const [brands, setBrands] = useState([]);
  const [showBrandModal, setShowBrandModal] = useState(false);
  const [newBrandName, setNewBrandName] = useState("");
  const [editProductId, setEditProductId] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);


  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  const [fieldNames, setFieldNames] = useState("");
  const [fields, setFields] = useState([]); 
  const [formValues, setFormValues] = useState({}); 
  const [images, setImages] = useState([]);



  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setNewProduct(prev => ({
      ...prev,
      [name]: name === "stock" ? Number(value) : value // stock stays numeric
    }));
    setShowBarcode(false);
  };



  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB

    const oversizedFiles = selectedFiles.filter(f => f.size > MAX_FILE_SIZE);
    if (oversizedFiles.length > 0) {
      showToast("Each file must be 2 MB or smaller. Oversized files were ignored.", "danger");
    }

 
    const validFiles = selectedFiles
      .filter(f => f.size <= MAX_FILE_SIZE)
      .map(file => ({
        file,
        preview: URL.createObjectURL(file),
        color: "#000000"
      }));

 
    setImages(prev => {
      const totalFiles = [...(prev || []), ...validFiles];
      if (totalFiles.length > 6) {
        showToast(`You can upload a maximum of 6 files. You already have ${prev?.length || 0} files.`, "danger");
        return prev;
      }
      return totalFiles;
    });

    e.target.value = null;
  };




const handleDeleteImage = async (index) => {
  const imgToDelete = images[index];
  if (!imgToDelete) return;
 
    try {
      await axios.delete(
        `https://api.skyguard.group/api/delete-inventory-image/${imgToDelete.inventoryId}/${imgToDelete.filename}`
      );
      showToast("Image deleted successfully", "success");
    } catch (err) {
      console.error("Failed to delete image from backend:", err);
      showToast("Failed to delete image", "danger");
    }


  setImages(prev => prev.filter((_, i) => i !== index));
};


  const handleRemoveFile = (index) => {
    const existingFiles = Array.isArray(files.file) ? files.file : [];
    const updatedFiles = existingFiles.filter((_, i) => i !== index);
    setFiles({ ...files, file: updatedFiles });
  };


  const handleEdit = (form) => {

    const staticKeys = [
      "id",
      "name",
      "short_name",
      "uom",
      "opening_qty",
      "mrp",
      "category",
      "warranty",
      "bin",
      "barcode",
      "model",
      "opening_value",
      "rate",
      "tax",
      "stock",
      "group_item",
      "description",
      "brand",
      "discount",
      "discount_vendor",
      "discount_retailer",
      "vendor",
      "retailer",
      "hsn",

      "min_stock",
      "barcodeChecked",
      "sr_no",
      "salePriceVendor",
      "salePriceRetailer",

    ];

    const dynamicKeys = Object.keys(form).filter(
      (key) =>
        !staticKeys.includes(key) &&
        key !== "file" &&
        key !== "video" &&
        key !== "deletedFiles" &&
        key !== "existingFiles"
    );



    const dynamicFields = dynamicKeys.map((key) => ({
      label: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
      key,
    }));



    const productData = {};

    staticKeys.forEach((k) => {
      if (k === "barcodeChecked") {
        productData[k] = form[k] == 1 ? true : false;
      } else {
        productData[k] = form[k] ?? "";
      }
    });

    dynamicKeys.forEach((k) => (productData[k] = form[k] ?? ""));


    setNewProduct(productData);
    setFields(dynamicFields);

 
const existingFiles = (() => {
  try {
    return typeof form.file === "string"
      ? JSON.parse(form.file)
      : Array.isArray(form.file)
      ? form.file
      : [];
  } catch (e) {
    console.warn("Invalid file JSON", form.file);
    return [];
  }
})();


    
const existingImages = existingFiles.map(f => ({
  file: null,
  preview: `https://api.skyguard.group/uploads/${f.filename}`,
  inventoryId:form.id,
    color: f.color || "#000000",
  filename: f.filename,
  isExisting: true
}));

setImages(existingImages);

    setFiles({
      file: [],
      existingFiles: existingFiles,
      deletedFiles: [],
      video: form.video || null,
    });

    

    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowAddForm(true);
  };


  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // bytes → MB
      if (fileSizeInMB > 2) {
        showToast("Video size is too large! Please upload a video smaller than 2MB.", 'danger');
        return; 
      }
      setFiles((prev) => ({
        ...prev,
        [e.target.name]: file,
      }));
    }
  };

// When generating dynamic fields
const dynamicKeys = fields.map(f => f.key); 



const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData();

  const normalizeValue = (value) => {
    if (value === undefined || value === null) return "";
    if (typeof value === "number" && isNaN(value)) return "";
    return value;
  };

  /* ---------------- STATIC FIELDS ---------------- */
  const staticFields = [
    "name","short_name","uom","opening_qty","mrp","category","warranty",
    "bin","barcode","model","opening_value","rate","tax","stock","group_item",
    "description","brand","vendor","retailer","discount",
    "discount_vendor","discount_retailer","hsn","min_stock",
    "sr_no","salePriceVendor","salePriceRetailer","dynamic_fields"
  ];

  staticFields.forEach((key) => {
    formData.append(key, normalizeValue(newProduct[key]));
  });

  /* ---------------- IMAGES ---------------- */
  const imageMeta = [];
  images.forEach((item) => {
    if (item.file) formData.append("file", item.file);

    imageMeta.push({
      color: item.color,
      filename: item.filename || null,
      originalName: item.file?.name || null,
      isExisting: !item.file
    });
  });
  formData.append("imageMeta", JSON.stringify(imageMeta));

  /* ---------------- DELETE FILES ---------------- */
  if (isEditMode) {
    formData.append("deletedFiles", JSON.stringify(files.deletedFiles || []));
  }

  /* ---------------- VIDEO ---------------- */
  if (files?.video) formData.append("video", files.video);

  /* ---------------- BOOLEAN ---------------- */
  formData.append("barcodeChecked", newProduct.barcodeChecked ? 1 : 0);

  try {
    if (isEditMode) {
      await axios.put(
        `https://api.skyguard.group/api/update-inventory/${newProduct.id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      showToast("Item updated successfully", "success");
    } else {
      await axios.post(
        "https://api.skyguard.group/api/add-inventory",
        formData
      );
      showToast("Item added successfully!", "success");
    }

    /* ---------------- RESET ---------------- */
    setNewProduct({
      name: "",
      short_name: "",
      uom: "",
      opening_qty: "",
      mrp: "",
      category: "",
      warranty: "",
      bin: "",
      barcode: "",
      model: "",
      opening_value: "",
      rate: "",
      tax: "",
      stock: "",
      group_item: "",
      description: "",
      brand: "",
      vendor: "",
      retailer: "",
      discount: "",
      discount_vendor: "",
      discount_retailer: "",
      hsn: "",
      min_stock: "",
      barcodeChecked: false,
      sr_no: "",
      salePriceVendor: "",
      salePriceRetailer: "",
      dynamic_fields: ""
    });

    setImages([]);
    setFiles({ file: [], existingFiles: [], deletedFiles: [], video: null });
    setShowAddForm(false);
    setIsEditMode(false);

    fecthDetail();

  } catch (err) {
    console.error("Submit error:", err);
    showToast(
      isEditMode ? "Failed to update item" : "Error adding item",
      "danger"
    );
  }
};

  const fecthDetail = async () => {
    try {
      const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');

      const items = resInventory.data.result || []; 
      setDetail(items);
    
      const uniqueCategories = [...new Set(items.map(inv => inv.category))];
      setCategories(uniqueCategories);
     

      const uniqueGroups = [...new Set(items.map(inv => inv.group_item))];
      setGroups(uniqueGroups);

      const uniqueUoms = [...new Set(items.map(inv => inv.uom))];
      setUoms(uniqueUoms);


      const uniqueBrands = [...new Set(items.map(inv => inv.brand))];
      setBrands(uniqueBrands);
    } catch (error) {
      console.log(error)
    }
  };

    const fetchAllCat = async () => { 
      try {
        const res = await axios.get('https://api.skyguard.group/api/fetch-all-category');
     setAllCat(res.data)
      } catch (error) {
        console.log(error)
      }
    };


  useEffect(() => {
    fecthDetail();
    fetchAllCat();
  }, []);


  const handleDelete = async (id) => {

    try {
      const res = await axios.delete(`https://api.skyguard.group/api/delete-inventory/${id}`);

      fecthDetail();
      showToast('Item Deleted successfuly !', 'success')
    } catch (error) {
      console.error("❌ Error deleting:", error.response?.data || error.message);
      showToast("Failed to delete item", 'danger');

    }
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);     
    setShowConfirm(true); 
  };
  const confirmDelete = () => {
    handleDelete(deleteId);
    setShowConfirm(false); 
  };




  const categoryOptions = [
    { value: "all", label: "All" }, // default option
    ...[...new Set(detail.map((inv) => inv.category))].map((cat) => ({
      value: cat,
      label: cat,
    })),
  ];


  const groupOptions = [
    { value: "all", label: "All" },
    ...Array.from(new Set(detail.map(inv => inv.group))).map(group => ({
      value: group,
      label: group
    }))
  ];




  const handlePreview = (product) => {
    setSelectedProduct(product);
  };



  const handleDownload = () => {
    if (!selectedProduct) return;

    const doc = new jsPDF();

    doc.setFontSize(14);
    doc.text(`${selectedProduct.name} Details`, 14, 15);

    // Table data
    const rows = [
      ["Item Name", selectedProduct.name || "-"],
      ["Model No", selectedProduct.model || "-"],
      ["Quantity", selectedProduct.opening_qty || "-"],
      ["Category", selectedProduct.category || "-"],
      ["Brand", selectedProduct.brand || "-"],
      ["Batch No.", selectedProduct.bin || "-"],
      ["MRP", selectedProduct.mrp || "-"],
    ];

    ;

    autoTable(doc, {
      body: rows,
      theme: "grid",
      styles: { halign: "left", valign: "middle" },
      startY: 25,
    });

    // Generate barcode in canvas and add to PDF
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, selectedProduct.barcode || "-", {
      format: "CODE128",
      displayValue: true,
    });

    const barcodeImg = canvas.toDataURL("image/png");

    // Place barcode below table
    const finalY = doc.lastAutoTable.finalY + 10; // position after table
    doc.text("Barcode:", 14, finalY);
    doc.addImage(barcodeImg, "PNG", 14, finalY + 5, 80, 30); // (x, y, width, height)

    // Save file
    doc.save(`${selectedProduct.name || "product"}.pdf`);
  };


  const filterDetail = detail.filter(tt => {
    const term = searchTerm.toLowerCase();
    return (
      (tt.name?.toLowerCase() || '').includes(term) ||
      (tt.brand?.toLowerCase() || '').includes(term) ||
      (tt.group?.toLowerCase() || '').includes(term) ||
      (tt.category?.toLowerCase() || '').includes(term)
    );
  });





  const handleGenerateFields = () => {
    const fieldArray = fieldNames
      .split("|")
      .map((name) => ({
        label: name.trim(),
        key: name.trim().toLowerCase().replace(/\s+/g, "_"),
      }))
      .filter((f) => f.key);

    setFields(fieldArray);


    setNewProduct((prev) => {
      const updated = { ...prev };
      fieldArray.forEach((f) => {
        if (!(f.key in updated)) {
          updated[f.key] = "";
        }
      });
      return updated;
    });
  };

  const calculateSalePrice = (mrp, discount) => {
    const m = parseFloat(mrp) || 0;
    const d = parseFloat(discount) || 0;
    return m - (m * d / 100);
  };


  useEffect(() => {
  const vendorPrice = calculateSalePrice(
    newProduct.vendor,
    newProduct.discount_vendor
  );

  const retailerPrice = calculateSalePrice(
    newProduct.retailer,
    newProduct.discount_retailer
  );

  setNewProduct((prev) => ({
    ...prev,
    salePriceVendor: vendorPrice,
    salePriceRetailer: retailerPrice
  }));
}, [
  newProduct.vendor,
  newProduct.discount_vendor,
  newProduct.retailer,
  newProduct.discount_retailer
]);


  const handleColorChange = (index, color) => {
    const updated = [...images];
    updated[index].color = color;
    setImages(updated);
  };

  return (
    <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <h3 className='my-3 fw-bold fs-5 golos'>Inventory</h3>

        <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

          <div className="mb-2 w-50 w-md-50 pe-md-2">
            <input
              className="form-control"
              placeholder="Search by Item Name, Category,Group..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>



          <div className="mb-2">
            <button
              className={`btn ${showAddForm ? 'btn-danger' : 'btn-success'}`}
              onClick={() => {
                setShowAddForm(!showAddForm);
                if (showAddForm) {
                  setNewProduct({ name: '', modelno: '', mrp: '', category: '', discount: '' });
                  setEditProductId(null);
                }
              }}
            >
              {showAddForm ? 'Cancel' : 'Add'}{' '}
              {showAddForm ? <FaTimes size={18} /> : <AiOutlinePlusCircle size={20} />}
            </button>
          </div>
        </div>

        {showAddForm && (
          <div className='card p-3 my-3' ref={formRef}>

            <h5>Add  Item Detail </h5>
            <form onSubmit={handleSubmit}>
              <div className='row g-3'>

                      {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {newProduct.name}
    </span>
  </div>
)}
                <div className="mb-0   bold">
                  <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                    Basic Item Detail
                  </h5>
                </div>

                <div className='col-md-4'>
                  <label> Item  Name</label>
                  <input
                    type='text'
                    className='form-control'
                    name='name'
                    value={newProduct.name}
                    placeholder='Item Name'
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className='col-md-4'>
                  <label>Short Name</label>
                  <input
                    type='text'
                    className='form-control'
                    name='short_name'
                    value={newProduct.short_name}
                    placeholder='Short Name'
                    onChange={handleInputChange}
                  />
                </div>



                <div className='col-md-4'>
                  <label>Opening Quantity</label>
                  <input
                    type='text'
                    className='form-control'
                    name='opening_qty'
                    value={newProduct.opening_qty}
                    placeholder='Opening Quantity'
                    onChange={handleInputChange}

                  />
                </div>



                <div className='col-md-4'>
                  <label>Bin No.</label>
                  <input
                    type='text'
                    className='form-control'
                    name='bin'
                    value={newProduct.bin}
                    placeholder='Bin No'
                    onChange={handleInputChange}

                  />
                </div>



                <div className="col-md-4">
                  <label>Barcode</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      name="barcode"
                      value={newProduct.barcode}
                      placeholder="Bar Code"
                      onChange={handleInputChange}
                      required
                    />


                    <div className="input-group-text">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={newProduct.barcodeChecked}
                        onChange={(e) =>
                          setNewProduct({ ...newProduct, barcodeChecked: e.target.checked })
                        }
                      />
                    </div>


                  </div>
                  {newProduct.barcodeChecked && newProduct.barcode && (
                    <div className="mt-3 text-center">
                      <Barcode value={newProduct.barcode} />
                    </div>
                  )}

                </div>


                <div className='col-md-4'>
                  <label>Model Number</label>
                  <input
                    type='text'
                    className='form-control'
                    name='model'
                    value={newProduct.model}
                    placeholder='Model No'
                    onChange={handleInputChange}

                  />
                </div>


                <div className='col-md-4'>
                  <label>Opening Value</label>
                  <input
                    type='text'
                    className='form-control'
                    name='opening_value'
                    value={newProduct.opening_value}
                    placeholder='Opening Vlaue'
                    onChange={handleInputChange}

                  />
                </div>
                <div className='col-md-4'>
                  <label>Purchasre Rate</label>
                  <input
                    type='text'
                    className='form-control'
                    name='rate'
                    value={newProduct.rate}
                    placeholder='Rate'
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className='col-md-4'>
                  <label>Stock</label>
                  <input
                    type='text'
                    className='form-control'
                    name='stock'
                    value={newProduct.stock}
                    placeholder='Stock'
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className='col-md-4'>
                  <label>Min Stock</label>
                  <input
                    type='number'
                    className='form-control'
                    name='min_stock'
                    value={newProduct.min_stock}
                    placeholder='Min Stock'
                    onChange={handleInputChange}
                    required
                  />
                </div>


                {/* <div className='col-md-4'>
                  <label>HSN Code</label>
                  <input
                    type='text'
                    className='form-control'
                    name='hsn'
                    value={newProduct.hsn}
                    placeholder='HSN Code'
                    onChange={handleInputChange}
                    required
                  />
                </div> */}
               

                <div className='col-md-4'>
                  <label>Sr No.</label>
                  <input
                    type='text'
                    className='form-control'
                    name='sr_no'
                    value={newProduct.sr_no}
                    placeholder='Sr No.'
                    onChange={handleInputChange}

                  />
                </div>

                  



                <div className="mb-0   bold">
                  <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                    Discount Section
                  </h5>
                </div>


                <div className='col-md-4'>
                  <lael>Festive Discount</lael>
                  <input
                    type='text'
                    className='form-control'
                    name='discount'
                    value={newProduct.discount}
                    placeholder='Discount'
                    onChange={handleInputChange}
                  />
                </div>


                <div className='col-md-4'>
                  <lael>Discount For Vendor</lael>
                  <input
                    type='text'
                    className='form-control'
                    name='discount_vendor'
                    value={newProduct.discount_vendor}
                    placeholder='Discount For Vendor'
                    onChange={handleInputChange}
                  />
                </div>

                <div className='col-md-4'>
                  <lael>Discount For Retailer</lael>
                  <input
                    type='text'
                    className='form-control'
                    name='discount_retailer'
                    value={newProduct.discount_retailer}
                    placeholder='Discount For Retailer'
                    onChange={handleInputChange}
                  />
                </div>


                <div className="mb-0   bold">
                  <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                    MRP Section
                  </h5>
                </div>


                <div className='col-md-4'>
                  <lael>Minimum Quantity </lael>
                  <input
                    type='text'
                    className='form-control'
                    name='mrp'
                    value={newProduct.mrp}
                    placeholder='Min QTY for vendor'
                    onChange={handleInputChange}

                  />
                </div>


                <div className='col-md-4'>
                  <lael>Vendor MRP</lael>
                  <input
                    type='text'
                    className='form-control'
                    name='vendor'
                    value={newProduct.vendor}
                    placeholder='Vendor MRP'
                    onChange={handleInputChange}
                  />
                </div>


                <div className='col-md-4'>
                  <lael>Retailer MRP</lael>
                  <input
                    type='text'
                    className='form-control'
                    name='retailer'
                    value={newProduct.retailer}
                    placeholder='Retailer MRP'
                    onChange={handleInputChange}
                  />
                </div>

            

<div className="col-md-4">
  <label>Sale Price Vendor</label>
  <input
    type="text"
    className="form-control"
    value={newProduct.salePriceVendor}
    readOnly
  />
</div>

<div className="col-md-4">
  <label>Sale Price Retailer</label>
  <input
    type="text"
    className="form-control"
    value={newProduct.salePriceRetailer}
    readOnly
  />
</div>


                <div className="mb-0   bold">
                  <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                    Other Detail
                  </h5>
                </div>


      


                <div className='col-md-4'>
                  <label htmlFor="uom-select">UOM:</label><br />
                  <select
                    id="uom-select"
                    className='form-control'
                    name="uom"
                    value={newProduct.uom}
                    onChange={(e) => {
                      if (e.target.value === "__add_new__") {
                        setShowUomModal(true); // open popup
                      } else {
                        setNewProduct({ ...newProduct, uom: e.target.value });
                      }
                    }}
                  >
                    <option value="">-- Select --</option>
                    {uoms.map((uom, index) => (
                      <option key={index} value={uom}>
                        {uom}
                      </option>
                    ))}
                    <option value="__add_new__">➕ Add New UOM</option>
                  </select>
                </div>

                {showUomModal && (
                  <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Add New UOM</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowUomModal(false)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter UOM"
                            value={newUomName}
                            onChange={(e) => setNewUomName(e.target.value)}
                          />
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              setNewUomName("");
                              setShowUomModal(false);
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => {
                              if (!newUomName.trim()) return;

                              // ✅ update frontend
                              setUoms([...uoms, newUomName]);
                              setNewProduct({ ...newProduct, uom: newUomName });

                              // reset + close
                              setNewUomName("");
                              setShowUomModal(false);
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}





                <div className="col-md-4">
                  <label>Category</label>
                  <br />
                  <select
                    name="category"
                    value={newProduct.category}
                    className='form-control'
                    onChange={(e) => {
                      if (e.target.value === "__add_new__") {
                
                        setShowCategoryModal(true);
                      } else {
                        setNewProduct({ ...newProduct, category: e.target.value });
                      }
                    }}
                    required
                  >
                    <option value="">-- Select --</option>
                    {categories.map((cat, index) => (
                      <option key={index} value={cat}>
                        {cat}
                      </option>
                    ))}
                    <option value="__add_new__">➕ Add New Category</option>
                  </select>
                </div>

                {/* <div className="col-md-4">
  <label>Category</label>
  <br />

  <select
    name="category"
    value={newProduct.category}
    className="form-control"
    onChange={(e) => {
      const selectedValue = e.target.value;

      if (selectedValue === "__add_new__") {
        setShowCategoryModal(true);
        return;
      }

      const selectedCategory = allCat.find(
        (cat) => cat.name === selectedValue
      );

      setNewProduct({
        ...newProduct,
        category: selectedValue,
        hsn: selectedCategory?.hsn_code || ""
      });
    }}
    required
  >
    <option value="">-- Select Category --</option>

    {allCat.map((cat) => (
      <option key={cat.id} value={cat.name}>
        {cat.name}
      </option>
    ))}

 
  </select>
</div> */}


                  


                {showCategoryModal && (
                  <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Add New Category</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowCategoryModal(false)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter category name"
                            value={newCategoryName}
                            onChange={(e) => setNewCategoryName(e.target.value)}
                          />
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              setNewCategoryName("");
                              setShowCategoryModal(false);
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => {
                              if (!newCategoryName.trim()) return;

                              // ✅ Update frontend
                              setCategories([...categories, newCategoryName]);
                              setNewProduct({ ...newProduct, category: newCategoryName });

                              // reset + close
                              setNewCategoryName("");
                              setShowCategoryModal(false);
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}


                <div className="col-md-4">
                  <label>Group</label>
                  <br />
                  <select
                    name="group"
                    className='form-control'
                    value={newProduct.group_item}  
                    // onChange={(e) => {
                    //   if (e.target.value === "__add_new__") {
                    //     setShowGroupModal(true); 
                    //   } else {
                    //     setNewProduct({ ...newProduct, group_item: e.target.value }); 
                    //   }
                    // }}

                     onChange={(e) => {
      const selectedValue = e.target.value;

      if (selectedValue === "__add_new__") {
        setShowCategoryModal(true);
        return;
      }

      const selectedCategory = allCat.find(
        (cat) => cat.name === selectedValue
      );

      setNewProduct({
        ...newProduct,
        group_item:selectedValue,
        hsn: selectedCategory?.hsn_code || ""
      });
    }}
                  >
                    <option value="">-- Select --</option>
                    {/* {groups.map((grp, index) => (
                      <option key={index} value={grp}>
                        {grp}
                      </option>
                    ))} */}

                        {allCat.map((cat) => (
      <option key={cat.id} value={cat.name}>
        {cat.name}
      </option>
    ))}
               
                  </select>
                </div>

                {showGroupModal && (
                  <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Add New Group</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowGroupModal(false)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter group name"
                            value={newGroupName}
                            onChange={(e) => setNewGroupName(e.target.value)}
                          />
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              setNewGroupName("");
                              setShowGroupModal(false);
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => {
                              if (!newGroupName.trim()) return;

                              // ✅ Add new group
                              setGroups([...groups, newGroupName]);

                              // ✅ Update selected value
                              setNewProduct({ ...newProduct, group_item: newGroupName });

                              // reset + close
                              setNewGroupName("");
                              setShowGroupModal(false);
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}


    <div className='col-md-4'>
                  <label>HSN Code</label>
                  <input
                    type='text'
                    className='form-control'
                    name='hsn'
                    value={newProduct.hsn}
                    placeholder='HSN Code'
                    onChange={handleInputChange}
                    required
                    disabled
                  />
                </div>

                <div className='col-md-4'>
                  <label>Warranty</label>
                  <br />

                  <select name='warranty'
                    value={newProduct.warranty}
                    className='form-control'
                    onChange={handleInputChange}
                    required
                  >

                    <option value="">-- Select --</option>
                    <option value="0">0 Month </option>
                    <option value="1">1 Month </option>
                    <option value="2">2 Month</option>
                    <option value="3">3 Month </option>
                    <option value='4' >4 Month</option>
                    <option value='5' >5 Month</option>
                    <option value='6' >6 Month</option>
                    <option value='7' >7 Month</option>
                    <option value='8' >8 Month</option>
                    <option value='9' >9 Month</option>
                    <option value='10' >10 Month</option>
                    <option value='11' >11 Month</option>
                    <option value='12' >12 Month</option>
                  </select>
                </div>



                <div className='col-md-4'>
                  <label>Tax</label>
                  <br />
                  <select name='tax'
                    className='form-control'
                    value={newProduct.tax}
                    onChange={handleInputChange}
                    required
                  >

                    <option value="">-- Select --</option>
                    <option>None</option>
                    <option>0 %</option>
                    <option>0.25 %</option>
                    <option>3 %</option>
                    <option>5 %</option>
                    <option>12 %</option>
                    <option>18 %</option>
                    <option>28 %</option>
                  </select>

                </div>



                <div className='col-md-4'>
                  <label>Brand</label>
                  <br />
                  <select
                    name="brand"
                    className='form-control'
                    value={newProduct.brand}
                    onChange={(e) => {
                      if (e.target.value === "__add_new__") {
                        setShowBrandModal(true);
                      } else {
                        setNewProduct({ ...newProduct, brand: e.target.value });
                      }
                    }}
                    required
                  >
                    <option value="">-- Select --</option>
                    {brands.map((br, index) => (
                      <option key={index} value={br}>
                        {br}
                      </option>
                    ))}
                    <option value="__add_new__">➕ Add New Brand</option>
                  </select>
                </div>
                {showBrandModal && (
                  <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Add New Brand</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowBrandModal(false)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter brand name"
                            value={newBrandName}
                            onChange={(e) => setNewBrandName(e.target.value)}
                          />
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              setNewBrandName("");
                              setShowBrandModal(false);
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => {
                              if (!newBrandName.trim()) return;

                              // ✅ update frontend
                              setBrands([...brands, newBrandName]);
                              setNewProduct({ ...newProduct, brand: newBrandName });

                              // reset + close
                              setNewBrandName("");
                              setShowBrandModal(false);
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}







                <div className="row mt-4">
                  <div className="col-md-4">
                    <label>Upload Images</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      multiple
                      onChange={handleFileChange}
                    />
                  </div>

                  <div className='col-md-4'>
                    <label>Upload Video</label>
                    <input
                      type="file"
                      className="form-control"
                      name="video"
                      accept="video/*"
                      onChange={handleVideoChange}
                    />
                    {isEditMode && files.video && typeof files.video === "string" && (
                      <div style={{ marginBottom: 10 }}>
                        <span>Previous Video: </span>
                        <a
                          href={`https://api.skyguard.group/uploads/${files.video}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {files.video}
                        </a>
                      </div>
                    )}

                  </div>


          <div className="col-md-12 mt-3">
  {images.map((img, index) => (
    <div key={index} className="d-flex align-items-center mb-3">
      <img
        src={img.preview}
        alt="preview"
        width="150"
        height="150"
        style={{ objectFit: "cover", marginRight: "15px" }}
      />

      <input
        type="color"
        value={img.color}
        onChange={(e) => handleColorChange(index, e.target.value)}
      />

      <span className="ms-2">{img.color}</span>

      <button
        type="button"
        className="btn btn-danger btn-sm ms-3"
        onClick={() => handleDeleteImage(index)}
      >
        Delete
      </button>
    </div>
  ))}
</div>


                </div>

                <div className="row">


                  <div className='col-md-6'>
                    <label>Description</label>

                    <textarea
                      className="form-control"
                      name="description"
                      rows='5'
                      value={newProduct.description}
                      onChange={handleInputChange}
                    // style={{ height: "120px", width: "100%" }}
                    />

                  </div>

                </div>






<div className="col-12 mt-3">
  <label>Dynamic Field</label>
  <input
    type="text"
    className="form-control"
    name="dynamic_fields"
    value={newProduct.dynamic_fields ?? ""}
    onChange={(e) =>
      setNewProduct({ ...newProduct, dynamic_fields: e.target.value })
    }
    placeholder="Enter dynamic value"
  />
</div>

              </div>
              <div className='col-md-4 mt-3'>

                {/* <button className='btn btn-primary ' type='submit'  >Add Item Detail </button> */}
                <button type="submit" className='btn btn-success w-10'>
                  {isEditMode ? "Update" : "Save"}
                </button>
                <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                  setShowAddForm(false);
                  setIsEditMode(false);
                  setNewProduct({
                    name: '',
                    short_name: '',
                    uom: "",
                    opening_qty: '',
                    mrp: "",
                    category: '',
                    warranty: '',
                    bin: '',
                    barcode: '',
                    model: '',
                    opening_value: '',
                    rate: '',
                    tax: '',
                    stock: '',
                    group_item: '',
                    description: '',
                    brand: '',
                    vendor: '',
                    retailer: '',
                    discount: '',
                    discount_vendor: '',
                    discount_retailer: '',
                    hsn: '',
                
                    min_stock: '',
                    sr_no: '',
                    salePriceVendor:'',
                    salePriceRetailer:'',
                    

                  })
                  setFiles({
                    file: null,

                    video: null
                  })

                  setFormValues({});


                  setFieldNames("");
                  setFields([]);
                  setImages([]);


                }}>
                  Cancel
                </button>
              </div>

            </form>

          </div>
        )}


 

        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>
            <thead className='table-info'>
              <tr>
                     <th scope='col'>SN</th>
                    <th scope='col'>Action</th>
           
                <th scope='col'>Item Name</th>

                <th scope='col'>Stock</th>
                <th scope='col'>Category</th>
                <th scope='col'>Group</th>
            
              </tr>
            </thead>
            <tbody>


              {filterDetail.length > 0 ? (
                filterDetail
                  .map((inv, index) => (
                    <tr key={inv.id}>
                      
                      <td>{index + 1}</td>
                          <td>

                       

                        <button
                          type="button"
                          className="btn btn-primary"
                          // onClick={() => handleEdit(inv)}
                           onClick={() => {
    handleEdit(inv);

    setTimeout(() => {
      formRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }}
                        >
                          <MdEdit />
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-danger"
                          onClick={() => handleDeleteClick(inv.id)}
                        >
                          <AiOutlineDelete size={20} />
                        </button>
                      </td>
                      <td>{inv.name}</td>

                      <td>{inv.stock}</td>
                      <td>{inv.category}</td>
                      <td>{inv.group_item}</td>
                  
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan="7">No data found.</td>
                </tr>
              )}




              {showConfirm && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                  <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Confirm Delete</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowConfirm(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <p>Are you sure you want to delete this item?</p>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowConfirm(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={confirmDelete}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </tbody>
          </table>



          {selectedProduct && (
            <div className="modal show d-block" tabIndex="-1">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Item Detail </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setSelectedProduct(null)}
                    ></button>
                  </div>


                  <div className="modal-body">
                    <div
                      className="card p-3"
                      style={{ borderRadius: "20px", boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}
                    >
                      {/* Table-like Structure */}
                      <table className="table table-bordered mb-4">
                        <tbody>
                          <tr>
                            <th style={{ width: "30%" }}>Item Name</th>
                            <td>{selectedProduct.name}</td>
                          </tr>
                          <tr>
                            <th>Model No</th>
                            <td>{selectedProduct.model || "-"}</td>
                          </tr>
                          <tr>
                            <th>Quantity</th>
                            <td>{selectedProduct.opening_qty || "-"}</td>
                          </tr>
                          <tr>
                            <th>Category</th>
                            <td>{selectedProduct.category || "-"}</td>
                          </tr>
                          <tr>
                            <th>Brand</th>
                            <td>{selectedProduct.brand || "-"}</td>
                          </tr>
                          <tr>
                            <th>Batch No.</th>
                            <td>{selectedProduct.bin || "-"}</td>
                          </tr>
                          <tr>
                            <th>MRP</th>
                            <td>{selectedProduct.mrp || "-"}</td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Barcode (outside table) */}
                      <div
                        className="text-center p-3"
                        style={{
                          borderRadius: "5px",
                          border: "1px dashed #ced4da",
                          backgroundColor: "#f1f3f5",
                        }}
                      >
                        <p className="mb-1 fw-bold">Barcode:</p>
                        <Barcode value={selectedProduct.barcode} />
                      </div>
                    </div>
                  </div>



                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setSelectedProduct(null)}
                    >
                      Close
                    </button>
                    <button className="btn btn-success" onClick={handleDownload}>
                      Download PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}


        </div>


      </div>
    </div>
  );
};

export default Inventory;
